export const DeprecatedAgentRunStatusValues = [
    'exported',
    'pending-export',
    'pending-predictions',
    'review-completed',
    'succeeded-predictions',
];
export const AgentRunStatusValues = [
    'archived',
    'completed',
    'error',
    'ready-for-review',
    'review-in-progress',
    'running',
];
export const AgentRunEventStatusValues = [
    'running',
    'pending',
    'ready',
    'succeeded',
    'failed',
    'in-progress',
    'ignored',
];
export const toListAgentRunsQueryParams = (options) => {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    const params = {};
    for (const [key, val] of Object.entries(options)) {
        switch (key) {
            case 'sort':
                {
                    const sorting = [];
                    for (const sort of val) {
                        sorting.push(`${sort.column}:${sort.order}`);
                    }
                    params[key] = sorting;
                }
                break;
            case 'createdTimeAfter':
            case 'createdTimeBefore':
            case 'updatedTimeAfter':
            case 'updatedTimeBefore':
                params[key] = val === null || val === void 0 ? void 0 : val.toISOString();
                break;
            default:
                params[key] = val;
                break;
        }
    }
    return params;
};
